module.exports = __webpack_public_path__ + "static/media/om_eyeshape_round_blue.273f7858.png";